import $http from '../../axios';
import { Notification, MessageBox } from 'element-ui';

export async function loadDocumentUploadProducts({ commit, state }, {document_id, file, model_id}) {
    let formData = new FormData();

    formData.append("document_id", document_id);
    formData.append("model_id", model_id);
    formData.append("file", file);
    commit('setModalsUploadProductsExcelPreloader', true);

    await $http.post('/api/importar-productos-documento-punto-venta', formData)
        .then(async (response) => {
            commit('pointOfSale/setDocument', response.data.data, { root: true });
            commit('setModalsUploadProductsExcelPreloader', false);
            await MessageBox.confirm('Los productos fueron cargados satisfactoriamente ', 'Exito', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'success',
                customClass: 'notification-success'
            });
            commit('setModalsUploadProductsExcelShow', false);
        })
        .catch((error) => {
            commit('setModalsUploadProductsExcelPreloader', false);
            MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
        })
}

export async function downloadDocumentsProductsTemplate({state, commit}, {document_id}) {
    let name = 'Plantilla productos.xlsx';

    try {
        const response = await $http({
            url: '/api/descargar-plantilla-cargar-productos-punto-venta?document_id='+document_id,
            method: 'GET',
            responseType: 'blob',
        });

        // Crea un enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();

        // Elimina el enlace después de la descarga
        link.remove();
    } catch (error) {
        await MessageBox.confirm(error.response.data.message, 'Error', {
            confirmButtonText: 'Aceptar',
            confirmButtonClass: 'btn-danger',
            showCancelButton: false,
            type: 'error',
            customClass: 'notification-error'
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/modal-upload-products-excel/actions.js